import React from "react";
import styled from "styled-components";

import Animation from "../resources/images/loading-animation.svg";
import { HFlex } from "../pandora/styled";


const Container = styled(HFlex)`
    align-items: center;
    justify-content: center;

    margin-top: 15px;
    border-radius: 5px;
`

const AnimationContainer = styled.img`
    width: 60px;
    height: 60px;
`

const Title = styled.h1`
    margin: 0;
    margin-left: 14px;
    text-align: left;
    font-size: 12px;
    font-family: 'Montserrat';
    font-weight: bold;
    color: white;
`


interface LoadingProps {
    message?: string;
    style?: React.CSSProperties;
}

const LoadingComponent = (props: LoadingProps): React.ReactElement => {
    return (
        <Container style={props.style}>
            <AnimationContainer src={Animation} />
            <Title>{props.message}</Title>
        </Container>
    )
}

export default LoadingComponent;